import { render, staticRenderFns } from "./site_other_list.vue?vue&type=template&id=581aa156&scoped=true&"
import script from "./site_other_list.vue?vue&type=script&lang=js&"
export * from "./site_other_list.vue?vue&type=script&lang=js&"
import style0 from "./site_other_list.vue?vue&type=style&index=0&id=581aa156&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581aa156",
  null
  
)

export default component.exports